import {useTranslation} from 'react-i18next';
import {HashRouter as Router, Route} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import MainMenu from './MainMenu';
import PeriodicTable from './PeriodicTable';
import MobileModal from './MobileModal';
import ReadElement from './ReadElement';
import Search from './Search';
import ElementList from './ElementList';
import {useEffect, useState} from "react";
import LanguageSelectModal from "./LanguageSelectModal";
import {isBrowser, isMobile, isIPad13} from "react-device-detect";
import GoToHomePage from "./GoToHomePage";
import i18next from "i18next";
import {YMInitializer} from 'react-yandex-metrika';
import ReactGA from 'react-ga';
import Tables from "./Tables";
import Table1 from "./Table1";
import Table2 from "./Table2";
import Table3 from "./Table3";
import Table4 from "./Table4";

const App = () => {

	useEffect(() => {
		ReactGA.initialize('UA-197143464-1');
		ReactGA.pageview(window.location.pathname + window.location.search);
	}, [])

	const {t} = useTranslation();
	const [languageSelect, setLanguageSelect] = useState(false);
	const openLangSelectModal = () => {
		setLanguageSelect(!languageSelect);
	}

	const renderContent = () => {
		if (isMobile || isIPad13) {
			return (
				<MobileModal/>
			)
		} else if (isBrowser) {
			return (
				<>
					<Helmet>
						<html lang={i18next.language.toUpperCase()}/>
						<title>{`${t('string.translate.name_ab')} ${new Date().getFullYear()}`}</title>
					</Helmet>
					<Router>
						<Route path='/' render={() => (
							<section className='page-main'>
								<YMInitializer accounts={[62339872]} options={{
									webvisor: true,
									clickmap: true,
									trackLinks: true,
									accurateTrackBounce: true
								}} version="2"/>
								<MainMenu onClick={openLangSelectModal}/>
								<div className='page-main__wrapper'>
									<h1 className='page-main__title'>
										{t('periodic_table_1')}
										<br/>
										{t('periodic_table_2')}
									</h1>
									<PeriodicTable/>
								</div>
							</section>
						)}/>
						<Route path='/:page' render={() => <GoToHomePage/>}/>
						<Route
							path='/element/:id'
							render={({match}) => {
								const {id} = match.params;
								return <ReadElement itemId={id}/>;
							}}
						/>
						<Route path='/search' render={() => <Search/>}/>
						<Route path='/element-list' render={() => <ElementList/>}/>
						<Route path='/tables' exact render={() => <Tables/>}/>
						<Route path='/tables/table-1' render={() => <Table1/>}/>
						<Route path='/tables/table-2' render={() => <Table2/>}/>
						<Route path='/tables/table-3' render={() => <Table3/>}/>
						<Route path='/tables/table-4' render={() => <Table4/>}/>
						{languageSelect ? <LanguageSelectModal onClick={openLangSelectModal}/> : null}
					</Router>
				</>
			);
		}
	}

	return (
		<>
			{renderContent()}
		</>
	);
};

export default App;
